import { useEffect } from 'react';
import CommonConfig from './constant';
import { useNavigate } from 'react-router-dom';
import Toast from '../components/Shared/Toast/Toast';

const checkTokenExpiration = async (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

const useTokenExpiration = () => {
  const navigate = useNavigate();
  const currentUser = CommonConfig.loginData();

  useEffect(() => {
    const checkAndLogout = async () => {
      const accessToken = CommonConfig.getCookie('access_token');
      if (!accessToken) return;
      const isTokenExpired = await checkTokenExpiration(accessToken);
      if (isTokenExpired) {
        Toast.error('Session token has expired. Initiating logout...');
        console.log('Token has expired. Logging out...');
        await CommonConfig.handleLogout(currentUser?._id, navigate);
      }
    };

    checkAndLogout();
    const intervalId = setInterval(checkAndLogout, 10000);
    return () => clearInterval(intervalId);
  }, [currentUser]);

};

export default useTokenExpiration;
